import {captureException} from '@sentry/nextjs'

const frontend = {
  failure: (message: string, data: unknown) => {
    // The `onSetItems` blanket mute that used to live here ("temporary measure
    // to reduce sentry spam — this error alone ran out our quota") is gone. It
    // was hiding one specific thing: /api/cart answering 429 to users behind
    // shared NAT, which pages/_app.tsx now reports as a warning at the source
    // instead of throwing. Muting the loudest caller also hid every OTHER way
    // onSetItems can fail, which is the wrong trade — if this gets loud again,
    // the fix belongs at whatever is failing, not here.
    if (data instanceof Error) {
      captureException(data, {tags: {ksebe: 'frontend.failure', message}})
    }
    if (process.env.NODE_ENV !== 'production') {
      console.error(`FRONTEND FAILURE ${message}`, data)
    }
  },
}

export {frontend}
